import React from 'react';
import { NavLink as RouterNavLink } from 'react-router-dom';
import {
  Button,
  Collapse,
  Container,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import axios from "axios";
import '@fortawesome/fontawesome-free/css/all.css';




interface NavBarProps {
  isAuthenticated: boolean;
  authButtonMethod: any;
  user: any;
}

interface NavBarState {
  isOpen: boolean;
  adminList: Array<string>
}



function UserAvatar(props: any) {
  // If a user avatar is available, return an img tag with the pic
  if (props.user.avatar) {
    return <img
      src={props.user.avatar} alt="user"
      className="rounded-circle align-self-center "
      style={{ width: '22px' }}></img>;
  }

  // No avatar available, return a default icon
  return <i
    className="far fa-user-circle fa-lg rounded-circle align-self-center "
    style={{ width: '22px' }}></i>;
}

function AuthNavItem(props: NavBarProps) {
  // If authenticated, return a dropdown with the user's info and a
  // sign out button
  if (props.isAuthenticated) {
    return (
      <UncontrolledDropdown>
        <DropdownToggle nav caret>
          <UserAvatar user={props.user} />
        </DropdownToggle>
        <DropdownMenu right>
          <p className="dropdown-item-text mb-0">{props.user.displayName}</p>
          <p className="dropdown-item-text text-muted mb-0">{props.user.email}</p>
          <DropdownItem divider />
          <DropdownItem onClick={props.authButtonMethod}>Sign Out</DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  }

  // Not authenticated, return a sign in link
  return (
    <NavItem>
      <Button
        onClick={props.authButtonMethod}
        className="btn-link nav-link border-0"
        color="link">Sign In</Button>
    </NavItem>
  );
}

export default class NavBar extends React.Component<NavBarProps, NavBarState> {
  constructor(props: NavBarProps) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      adminList: []
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  componentDidMount() {
    var url = "https://encontech.azurewebsites.net/api/admins";
    //var url = "http://localhost:5000/api/admins";

    axios.get(url).then((response) => {
      
      var al = response.data.map(function(admin: { id: number, email:string }) {
        return admin.email;
      });
  
        this.setState({
          adminList: al
        });
    });
  }

  render() {

    
var isAdmin = this.state.adminList.includes(this.props.user.email);



    // Only show Add a Job Link nav item if logged in
    let AdministrationLink = null;
    let JobsLink = null;
    let emailLink = null;


    if (this.props.isAuthenticated ) {
    if(isAdmin)
    {
      AdministrationLink = (
        <NavItem>
          <RouterNavLink to="/Administration" className="nav-link" exact>Administration</RouterNavLink>
        </NavItem>
      );
      }
      JobsLink = (
        <NavItem>
          <RouterNavLink to="/OnlineJobs" className="nav-link" exact>Jobs</RouterNavLink>
        </NavItem>
      );

      emailLink = (this.props.user.email);
    }
    return (
     
     <div>
      <div className="navbartoparea" >
        <div className="container " >
         <div className="row " >
          <div className="col-md-6 text-left mbtopbarleft" >3433 Sunset Ave Ocean, NJ 07712</div>
          <div className="col-md-6 text-right mbtopbarright" >{emailLink}</div>        
         </div>
        </div>
      </div>
      <Navbar color="light" light expand="md"  className="borderbottomline">
        <Container>
          <NavbarBrand href="/"><img src="img/logo_01.png" className="logo img-responsive" /></NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="mr-auto" navbar></Nav>
            <Nav className="justify-content-end" navbar>
              <NavItem>
                <RouterNavLink to="/" className="nav-link" exact>Home</RouterNavLink>
              </NavItem>
              {JobsLink}
              {AdministrationLink}
              <AuthNavItem
                isAuthenticated={this.props.isAuthenticated}
                authButtonMethod={this.props.authButtonMethod}
                user={this.props.user} />
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </div>
    );
  }
}